export enum FeatureFlag {
  EnableEInvoicing = 'signup.enable-e-invoicing',
  EnableAlternativeSidebarImage = 'signup.enable-alternative-sidebar-image',
}

export enum SidebarImage {
  Default = 'default',
  FocusAI = 'focus-ai',
}
